<template>
  <div>
    <b-container fluid class="footer overflow-hidden">
      <b-container>
        <b-row class="animated wow fadeInUp">
          <b-col md="5" lg="3">
            <h3>
              <a href="tel:0048601403460">601 403 460</a>
            </h3>
          </b-col>
          <b-col md="7" lg="3">
            <h3>Linki</h3>
            <router-link to="/">O firmie</router-link>
            <br />
            <router-link to="/produkty">Produkty</router-link>
            <br />
            <router-link to="/instrukcja">Instrukcja</router-link>
            <br />
            <router-link to="/kontakt">Kontakt</router-link>
          </b-col>
          <b-col md="12" lg="6">
            <h3>Napisz wiadomość</h3>

            <b-form @submit="onSubmit" id="form-msg">
              <div class="left-form">
                <b-form-group id="input-group-1">
                  <b-form-input id="input-1" v-model="form.name" placeholder="Imię i nazwisko"></b-form-input>
                </b-form-group>
                <b-form-group id="input-group-2">
                  <b-form-input  id="input-2" v-model="form.email" required placeholder="E-mail" v-validate="'required|email'" name="email"></b-form-input>
                  <b-tooltip :show.sync="errors.has('email') && form.email.length > 0" target="input-group-2" triggers="none" placement="top">
                    Podaj poprawny <strong>e-mail</strong>
                  </b-tooltip>
                </b-form-group>
                <b-form-group id="input-group-3">
                  <b-form-input id="input-3" v-model="form.phone" placeholder="Telefon"></b-form-input>
                </b-form-group>
              </div>

              <div class="right-form">
                <b-form-textarea id="textarea" v-model="form.msg" required placeholder="Wpisz wiadomość..."></b-form-textarea>
                <b-button type="submit" variant="primary">Wyślij</b-button>
                <b-tooltip :show.sync="form.msg.length < 10 && form.msg.length > 0" target="textarea" triggers="none" placement="top">
                  Wiadomość <strong>zbyt krótka</strong>
                </b-tooltip>
              </div>
            </b-form>
          </b-col>
        </b-row>
      </b-container>
    </b-container>
    <b-container fluid class="socket"> <span class="animated wow fadeIn" data-wow-delay="1s" data-wow-offset="-50"> Nacinarki - {{ rok }} </span>  </b-container>
    
    <!-- modale itp -->
    <b-modal id="wrong-form-modal">
      <p class="alert alert-danger" role="alert">Wypełnij poprawnie formularz</p>
      <template slot="modal-footer" slot-scope="{ ok }">
        <b-button  variant="primary" @click="ok()">
          OK
        </b-button>
      </template>
    </b-modal>
    <b-modal id="error-form-modal">
      <p class="alert alert-danger" role="alert">Coś poszło nie tak</p>
      <template slot="modal-footer" slot-scope="{ ok }">
        <b-button  variant="primary" @click="ok()">
          OK
        </b-button>
      </template>
    </b-modal>
    <b-modal id="success-form-modal">
      <p class="alert alert-success" role="alert">Dziękujemy za wysłanie wiadomości</p>
      <template slot="modal-footer" slot-scope="{ ok }">
        <b-button  variant="primary" @click="ok()">
          OK
        </b-button>
      </template>
    </b-modal>

    <div id="loading" v-if="showLoading"></div>
    <!-- modale itp -->

  </div>
</template>

<script>
export default {
  name: 'Footer',
  components: {},
  data() {
    return {
      form: {
        email: '',
        name: '',
        phone: '',
        msg: ''
      },
      showLoading: false,
    }
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault()
      if (this.errors.has('email') || this.form.msg.length < 10) {
        this.$bvModal.show('wrong-form-modal')
      } else{
        this.showLoading = true
        let callbackResponse = (data) => {
          this.showLoading = false
          if (data == "success") {
            this.$bvModal.show('success-form-modal')
            this.form.email = ''
            this.form.name = ''
            this.form.phone = ''
            this.form.msg = ''
          } else {
            this.$bvModal.show('error-form-modal')
          }
        }

        let formdata = new FormData()
        formdata.append("name", this.form.name)
        formdata.append("email", this.form.email)
        formdata.append("phone", this.form.phone)
        formdata.append("msg", this.form.msg)
        let ajax = new XMLHttpRequest()
        ajax.onreadystatechange = function() {
          if (this.readyState == 4 && this.status == 200) {
            callbackResponse(this.responseText)
          }
        }
        ajax.open("POST", "send_form.php")
        ajax.send(formdata)

        return false  	
      }
    }
  },
  computed: {
    rok: function() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'node_modules/bootstrap/scss/functions';
@import 'node_modules/bootstrap/scss/variables';

h3 {
  font-size: 36px;
  font-weight: bold;
  text-align: left;
  color: #777;
  margin-bottom: 20px;
  margin-top: 15px;
  text-transform: uppercase;
}

p {
  font-size: 22px;
  color: #777;
  line-height: 24px;
}
h5 {
  font-size: 26px;
  font-weight: 500;
  margin-bottom: 14px;
  line-height: 28px;
}

.onas {
  padding: 100px 0;
}
.left-form {
  flex: 1 1 165px;
  margin-right: 20px;
  @media (max-width: map-get($grid-breakpoints, 'sm') - 1) {
    margin-right: 0;
    flex: 1 1 auto;
  }
}
.right-form {
  flex: 1 1 263px;
  display: flex;
  flex-direction: column;
  @media (max-width: map-get($grid-breakpoints, 'sm') - 1) {
    flex: 1 1 auto;
  }
}
textarea,
textarea:focus {
  resize: none;
  padding: 15px;
  letter-spacing: -0.3px;
  height: 96px !important;
  margin-bottom: 17px;
  background: black;
  border-color: #565656;
  color: white;
}
input,
input:focus {
  letter-spacing: -0.3px;
  background: black;
  border-color: #565656;
  color: white;
}
.btn {
  margin: 0;
  font-weight: normal;
  height: 39px;
}
#form-msg {
  display: flex;
  @media (max-width: map-get($grid-breakpoints, 'sm') - 1) {
    flex-direction: column;
  }
}
.footer {
  background: #252525;
  padding: 35px 0 30px;
}
.footer a{
  transition: all 300ms ease;
  &:hover{
   text-decoration: none;
  }
}
.socket{
      background: #171717;
    color: #909090;
    font-weight: 300;
    padding: 7px 0;
    text-align: center;
    font-size: 14px;
}

#loading{
  position: fixed;
  top:0;
  left:0;
  background: rgba(255,255,255, 0.85) url('./../assets/loading.gif') center center;
  width: 100vw;
  height: 100vh;
  z-index: 999;  
}

</style>